export default "__VITE_ASSET__CYTfkjiD__"